import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const Home = () =>import('@/views/Home.vue')
const Member = () =>import('@/views/Member.vue')
const Station = () =>import('@/views/Station.vue')
const Connector = () =>import('@/views/Connector.vue')
const Charging = () =>import('@/views/Charging.vue')
const ChargingStop = () =>import('@/views/ChargingStop.vue')
const OrderList = () =>import('@/views/OrderList.vue')
const OrderDetail = () =>import('@/views/OrderDetail.vue')
const ShouQuan = () =>import('@/views/ShouQuan.vue')
const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/member",
        name: "Member",
        component: Member
    },
    {
        path: "/station",
        name: "Station",
        component: Station
    },
    {
        path: "/connector",
        name: "Connector",
        component: Connector
    },
    {
        path: "/charging",
        name: "Charging",
        component: Charging
    },
     {
        path: "/chargingStop",
        name: "ChargingStop",
        component: ChargingStop
    },
    {
        path: "/OrderList",
        name: "OrderList",
        component: OrderList
    },
    {
        path: "/OrderDetail",
        name: "OrderDetail",
        component: OrderDetail
    },
    {
        path: "/ShouQuan",
        name: "ShouQuan",
        component: ShouQuan
    }

  
]

const router = new VueRouter({
  mode: 'hash',  // 使用hash模式（默认），URL中有#
  base: process.env.BASE_URL,
  routes,
  // 滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router